// 웨어러블 기기(AirPods 등) 구성 선택 옵션
export interface DeviceConfiguration {
  id: string;
  name: string;
  description: string;
  image: string;
  icon: string; // Material UI 아이콘명
}

// AirPods 구성 선택지
export const AIRPODS_CONFIGURATIONS: DeviceConfiguration[] = [
  {
    id: 'fullset',
    name: '풀세트',
    description: '유닛 양쪽 + 본체',
    image: '/assets/airPot/full.png',
    icon: 'HeadphonesIcon'
  },
  {
    id: 'earbuds-set',
    name: '유닛 세트',
    description: '유닛 양쪽만',
    image: '/assets/airPot/unit.png',
    icon: 'AudiotrackIcon'
  },
  {
    id: 'single-earbud',
    name: '유닛 1쪽',
    description: '왼쪽 또는 오른쪽',
    image: '/assets/airPot/left.png',
    icon: 'VolumeUpIcon'
  },
  {
    id: 'case-only',
    name: '본체만',
    description: '충전 케이스만',
    image: '/assets/airPot/only.png',
    icon: 'BatteryChargingFullIcon'
  }

];

// 구성 선택 가능한 카테고리
export const CONFIGURATION_CATEGORIES = ['웨어러블'];

// 구성 선택이 필요한지 확인하는 함수 (AirPods Max 제외)
// 🔥 웨어러블 카테고리의 모든 모델에 구성 선택 표시 (신규 추가 모델 포함)
export const needsConfigurationSelection = (category: string, modelName: string): boolean => {
  // 웨어러블 카테고리가 아니면 false
  if (!CONFIGURATION_CATEGORIES.includes(category)) {
    return false;
  }
  
  // AirPods Max는 구성선택 제외 (헤드폰이므로 풀세트/유닛 구분 없음)
  const lowerName = modelName.toLowerCase();
  if (lowerName.includes('max') || lowerName.includes('맥스')) {
    return false;
  }
  
  // 🎧 웨어러블 카테고리의 모든 모델에 구성 선택 필요
  // (AirPods뿐 아니라 신규 추가된 모든 웨어러블 모델 포함)
  return true;
};

// 구성 정보를 포함한 디바이스 정보 타입
export interface DeviceWithConfiguration {
  deviceType: string;
  deviceModel: string;
  configuration?: DeviceConfiguration;
}